import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/ErrorPage.css';

const ErrorPage = () => {
  return (
    <div className="error-page">
      <div className="error-container">
        <h1>Error</h1>
        <p>Sorry, an error occurred while processing your request.</p>
        <p>Please try again later or contact your system administrator if the problem persists.</p>
        
      </div>
    </div>
  );
};

export default ErrorPage;